import {
  Component, OnInit,
  ElementRef
} from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
export interface ConfirmModelprivilege {
  title: string;
  data: any;
}

@Component({
  selector: 'app-privilege-search',
  templateUrl: './privilege-search.component.html',
  styleUrls: ['./privilege-search.component.css']
})
export class PrivilegeSearchComponent extends DialogComponent<ConfirmModelprivilege, boolean> implements ConfirmModelprivilege, OnInit {
  title: string;
  message: string;
  data: any;
  loading: boolean = false
  result: any = { item: [], result: false }
  rtnData: any;
  selectedRow: number = -1
  sliceStrat: number = 0
  sliceEnd: number = 10
  Unit: string = ""
  f: any = {
    Name: "",
    Company: "",
    Branch: "",
    Location: "",
  };
  fullData: any;
  private el: ElementRef
  constructor(dialogService: DialogService) {
    super(dialogService);
    this.fullData = this.data
  }

  ngOnInit() {
    this.fullData = this.data;
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 10
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 10
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.data.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 11
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "Name":
          this.f.Name = e.target.value;
          break;
        case "Company":
          this.f.Company = e.target.value;
          break;
        case "Branch":
          this.f.Branch = e.target.value;
          break;
        case "Location":
          this.f.Location = e.target.value;
          break;
      }
      this.selectedRow = 0;
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.data.find(x => x.Name == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/privilege-search/privilege-search.component.ts